export enum DropDownType {
    Car = 1,
    String,
    LabelValue,
}